<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="NewFeedSource"
    title="New Feed Source"
    icon="language"
    submit-name="Create"
    full-height
    :steps="4"
    @[Events.PREV_STEP]="back"
    @[Events.NEXT_STEP]="next"
    @[Events.CHANGE_STEP]="onChangeStep"
    @[Events.SUBMIT]="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <component
      :is="feedSourceStep"
      v-for="(feedSourceStep, index) in feedSourceSteps"
      v-show="index + 1 === currentStep"
      :key="'feedSourceStep' + index"
      :ref="'step' + (index + 1)"
      v-model="data"
      @[Events.NEXT_STEP]="nextFromInput"
      @[Events.SUBMIT]="submitFromInput"
    />
  </form-modal>
</template>

<script>
import FeedSourceStep1 from '@/components/modals/feedSources/FeedSourceStep1'
import FeedSourceStep2 from '@/components/modals/feedSources/FeedSourceStep2'
import FeedSourceStep3 from '@/components/modals/feedSources/FeedSourceStep3'
import FeedSourceStep4 from '@/components/modals/feedSources/FeedSourceStep4'
import {mapGetters} from 'vuex'
import {Events, Modal, FeedSources} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'

export default {
  name: 'ModalNewFeedSource',
  components: {
    FeedSourceStep4,
    FeedSourceStep3,
    FeedSourceStep2,
    FeedSourceStep1,
    FormModal
  },
  data() {
    return {
      Events,
      FeedSources,
      modalName: Modal.NEW_FEED_SOURCE,
      modalRef: null,
      currentStep: 1,
      data: {
        actorId: null,
        type: null,
        source: null,
        url: null,
        title: '',
        description: '',
        tags: null
      }
    }
  },
  computed: {
    ...mapGetters(['currentLandscape']),
    feedSourceSteps() {
      return [
        'FeedSourceStep1',
        'FeedSourceStep2',
        'FeedSourceStep3',
        'FeedSourceStep4'
      ]
    }
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
  },
  methods: {
    back() {
      const step = this.$refs['step' + this.currentStep][0]
      step.clear()
      this.modalRef.prevSuccess()
    },
    nextFromInput() {
      this.modalRef.next()
    },
    async next() {
      const step = this.$refs['step' + this.currentStep][0]
      try {
        await step.validate()
        this.modalRef.nextSuccess()
      } catch (e) {
        this.modalRef.nextFails()
      }
    },
    onChangeStep(currentStep) {
      this.currentStep = currentStep
      const step = this.$refs['step' + this.currentStep][0]
      step.init()
    },
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      this.$store
        .dispatch('createSource', this.data)
        .then(() => {
          this.modalRef.submitSuccess()
        })
        .catch(error => {
          this.modalRef.submitFails(error.devMessage)
        })
    },
    modalClosed({fromSubmit}) {
      this.currentStep = 1
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, 'New Source created')
      }
    }
  }
}
</script>

<style>
.NewFeedSource {
  .Modal-wrapper {
    width: 700px;
  }
}
</style>
